import axios from "axios";
import apiurl from "../apiendpoint/apiendpoint";
import { gettoken } from "../../../../shared/services/token/token";

export const saveBanners = async(datas) => {
    try {
        const formData = new FormData();
        
        for (const key in datas) {
            if (key === 'DesktopImage' || key === 'MobileImage') {
                if (datas[key] && datas[key] instanceof File) {
                    formData.append(key, datas[key]);
                }
            } else {
                formData.append(key, datas[key]);
            }
        }
        
        var res = await axios.post(`${apiurl()}/homeBanner/apisavebanner`, formData, {headers: {"Authorization": `Bearer ${gettoken()}`,"Content-Type": "multipart/form-data"}});
        return res.data;
    } catch(err) {
        console.log('Error in savecollection:', err);
        throw err;
    }
}

export const getallBanner = async(params)=>{
    var res=await axios.get(`${apiurl()}/homeBanner/apigetadminallbanner`,{
        params:params, 
        headers: {"Authorization" : `Bearer ${gettoken()}`}
    });
    return res.data;
}

 export const gethomebannerFilterOptions = async(data)=>{
    var res=await axios.post(`${apiurl()}/homeBanner/gethomebannerfilteroptions`,{field:data},{headers: {"Authorization" : `Bearer ${gettoken()}`}});
    return res.data;
 }

export const updatedBanner = async(datas) => {
    try {
        const formData = new FormData();
        
        for (const key in datas) {
            if (key === 'DesktopImage' || key === 'MobileImage') {
                if (datas[key] && datas[key] instanceof File) {
                    formData.append(key, datas[key]);
                }
            } else if (key !== '_id') {
                formData.append(key, datas[key]);
            }
        }
        
        var res = await axios.put(`${apiurl()}/homeBanner/apiupdatebanner`, formData, {
            params: {_id: datas?._id}, 
            headers: {
                "Authorization": `Bearer ${gettoken()}`,
                "Content-Type": "multipart/form-data"
            }
        });
        return res.data;
    } catch(err) {
        console.log('Error in update Homebanner:', err);
        throw err;
    }
}

export const deleteBanner = async(id) => {
    var res = await axios.delete(`${apiurl()}/homeBanner/apideletebanner`, {params: {_id: id}, headers: {"Authorization" : `Bearer ${gettoken()}`}});
    return res.data;
}

export const getallCustomerBanner = async(params)=>{
    var res=await axios.get(`${apiurl()}/homeBanner/apigetCustomerbanner`,{params:params, headers: {"Authorization" : `Bearer ${gettoken()}`}});
    return res.data;
}